import {
  AUTH_PATHS,
  CreateSessionRequest,
  ME_PATH,
  MeResponse,
  meResponseSchema,
  RefreshResponse,
  refreshResponseSchema,
} from '@quizdb/common';
import { quizdbApi } from '../api/quizdbApi';

/** The API's session endpoints (QZ-D29) and the caller's identity, as RTK Query endpoints (QZ-D8). */
export const authApi = quizdbApi.injectEndpoints({
  endpoints: (builder) => ({
    createSession: builder.mutation<void, { accessToken: string; refreshToken: string }>({
      query: ({ accessToken, refreshToken }) => {
        const body: CreateSessionRequest = { refreshToken };
        return {
          url: AUTH_PATHS.session,
          method: 'POST',
          body,
          headers: { Authorization: `Bearer ${accessToken}` },
          credentials: 'include',
        };
      },
    }),
    refreshSession: builder.mutation<RefreshResponse, void>({
      query: () => ({ url: AUTH_PATHS.refresh, method: 'POST', credentials: 'include' }),
      transformResponse: (response: unknown) => refreshResponseSchema.parse(response),
    }),
    signOut: builder.mutation<void, void>({
      query: () => ({ url: AUTH_PATHS.signOut, method: 'POST', credentials: 'include' }),
    }),
    getMe: builder.query<MeResponse, void>({
      query: () => ME_PATH,
      transformResponse: (response: unknown) => meResponseSchema.parse(response),
      providesTags: ['Me'],
    }),
  }),
});

export const { useGetMeQuery } = authApi;
